import { render, staticRenderFns } from "./WorkflowPrepAuditTrail.vue?vue&type=template&id=467add63"
import script from "./WorkflowPrepAuditTrail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports